import React, { useState } from "react";
import Popover from "@material-ui/core/Popover";
import styles from "./pop-over.module.scss";

const PopOver = ({ children, content }) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(undefined);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(undefined);
  };

  return (
    <div>
      <div className="pointer" onClick={handleClick}>
        {children}
      </div>
      <Popover
        id={open ? "pop-over-content" : undefined}
        open={open}
        anchorEl={anchorEl}
        className={styles.popoverContainer}
        onClose={handleClose}
        // keepMounted
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className={styles.arrow}></div>
        <div className={styles.content}>{content}</div>
      </Popover>
    </div>
  );
};

export default PopOver;
